export function findErrorsInModel(model, schema) {
  let errors = {};
  for (const item in model) {
    if (typeof schema[item] === 'object') {
      errors = {
        ...errors,
        [`${item}`]: {
          ...findErrorsInModel(model[item], schema[item])
        }
      };
    }
    if (typeof schema[item] === 'function') {
      const errorMessage = schema[item](model[item]);
      if (errorMessage) {
        errors[item] = errorMessage;
      }
    }
  }
  return errors;
}
